<div class="loader-container">
  <div class="d-flex-col">
    <span>
      <div class="div"></div>
      <div class="div"></div>
      <div class="div"></div>
      <div class="div"></div>
      <div class="div"></div>
    </span>
    <span class="loading-text">Loading</span>
  </div>
</div>
